import { render, staticRenderFns } from "./diagnostic-report.vue?vue&type=template&id=57c9017c&scoped=true&"
import script from "./diagnostic-report.vue?vue&type=script&lang=js&"
export * from "./diagnostic-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c9017c",
  null
  
)

export default component.exports